import React from 'react';
import { Accordion } from "flowbite-react";
import * as C from "../componentsM/index";

const TisHistory = () => {
  const contentInstance = new getContent();

  return (
    <>
      <C.Hero
        title={"TIS HISTORY"}
        image={"/hero/history.jpg"}
        tagLine={"The International School (TIS) Established In 1996"}
      />

      <section className='px-8 py-20 flex flex-col gap-6'>
        <p>{contentInstance.content}</p>


        <Accordion collapseAll className='border-0'>

          <Accordion.Panel>
            <Accordion.Title>{contentInstance.accordionTitle1}</Accordion.Title>
            <Accordion.Content>
              <p className="mb-2 text-gray-500 dark:text-gray-400">
                {contentInstance.accordionContent1}
              </p>
            </Accordion.Content>
          </Accordion.Panel>

          <Accordion.Panel>
            <Accordion.Title>{contentInstance.accordionTitle2}</Accordion.Title>
            <Accordion.Content>
              <p className="mb-2 text-gray-500 dark:text-gray-400">
                {contentInstance.accordionContent2}
              </p>
            </Accordion.Content>
          </Accordion.Panel>


        </Accordion>


        <h1 className='text-2xl font-light mt-8 '>Time Line</h1>


        <Accordion collapseAll className='border-0  rounded-sm'>

        {contentInstance.timeLine.map((v,i) => <Accordion.Panel className='bg-gray-200 my-10' key={i} >
            <Accordion.Title  >{v.year}</Accordion.Title>
            <Accordion.Content className='bg-white'>
              <ul className="mb-2 text-gray-500 dark:text-gray-400">
              {v.events.map(c => <li key={c}>{c}</li>)}
              </ul>
            </Accordion.Content>
          </Accordion.Panel>)}

        </Accordion>


      </section>
    </>
  );
};

export default TisHistory;





class getContent {



  timeLine = [
    {
      year: "1996 – 1997",
      events: [
        "Set up infrastructure",
        "Developed Academic programme",
        "Developed Administrative procedures",
        "Opened Admissions for grade 1 to 7",
        "Authorisation visit by IB inspector",
        "Authorisation letter for MYP from IBO",
        "Teachers sent to Bangkok for training",
        "Dawn supplement",
        "School Carnival",
        "Developed Academic programme for grade 8"
      ]
    },
    {
      year: "1997 – 1998",
      events: [
        "Opened grade 8 for admission",
        "Developed Design and Technology Workshop",
        "Principal attended Heads of School Conference",
        "Halloween Carnival",
        "Introduced annual cricket match between staff and students to be played on 14th August (Independence Cup)",
        "Developed Academic programme for grade 9"
      ]
    },
    {
      year: "1998 – 1999",
      events: [
        "Opened grade 9 for admission",
        "Introduced security deposit",
        "Students’ trip to North Pakistan & Afghanistan",
        "Swimming Gala, Olympics introduced as annual events",
        "Organised first Drama Festival",
        "Developed curriculum for grade 10"
      ]
    },
    {
      year: "1999 – 2000",
      events: [
        "Opened grade 10 for admission",
        "Graduated first MYP batch of 21 students",
        "Students’ trip to Mohenjo-Daro",
        "Dawn supplement",
        "Added second building",
        "Developed Academic programme for High School (DP)"
      ]
    },
    {
      year: "2000 - 2001",
      events: [
        "Opened grade 11 for admission",
        "Set up infrastructure and procedures for High School",
        "Teachers sent to Bahrain and Hong Kong for Diploma Training",
        "Students attended Model United Nations(MUN) Programme in Sri Lanka",
        "Authorisation letter for Diploma Programme from IBO"
      ]
    },
    {
      year: "2001 - 2002",
      events: [
        "Set up infrastructure and procedures for pre-school",
        "Authorisation letter for Diploma Programme from IBO",
        "Set up College advisory service",
        "Graduated first IB Diploma batch of 30 students to College and Universities across the world including Pakistan"
      ]
    },
    {
      year: "2002 - 2003",
      events: [
        "Graduated MYP and Diploma batches to College and Universities across the world including Pakistan"
      ]
    },
    {
      year: "2003 - 2004",
      events: [
        "Registered with Cambridge International Examinations, UK",
        "Registered with Edexcel International, UK"
      ]
    },
    {
      year: "2004 – 2008",
      events: [
        "Graduated MYP and Diploma batches to College and Universities across the world including Pakistan",
        "Introduced Rowing and Sailing as sporting events",
        "Participated in the first Inter-School Rowing Regatta"
      ]
    },
    {
      year: "2008 – 2009",
      events: [
        "Organised and hosted the first TIS Model United Nations Conference"
      ]
    },
    {
      year: "2009 – 2010",
      events: [
        "Many teachers register for the 6-week IB authorised online workshops"
      ]
    },
    {
      year: "2010 – 2011",
      events: [
        "Signed a Memorandum of Understanding (MOU) with Institute of Education (IOE), University of London for the development of teachers and educational",
        "Registered Trust for Advancement for Knowledge and Understanding (TAKE)",
        "Conducted the first Short Course in Teaching and School Leadership in association with IOE",
        "Completed the mandatory 5 years review of IB Diploma Programme"
      ]
    },
    {
      year: "2011 – 2012",
      events: [
        "Chairperson of Board and Head of school attended the IB Heads Conference in Singapore to raise the issue of IB in Pakistan with IBO leadership",
        "Attended the first South Asian IB Schools’ Association (SAIBSA) conference in Kathmandu, Nepal"
      ]
    },
    {
      year: "2012 – 2013",
      events: [
        "Secures IB Primary Years Programme (PYP) candidate status to become a full IB World School with all three programmes",
        "Completes the first IB PYP consultation visit",
        "Completes the mandatory 5 years review of the IB Middle Years Programme (MYP)",
        "Attends the MYP Next Chapter workshop in Malaysia to commence the transition of the programme",
        "Secures accreditation by The College of Teachers (TCOT) as CPD Lead School to offer UK Certified Professional Development in Pakistan"
      ]
    },
    {
      year: "2013 - 2014",
      events: [
        "PYP consultancy successfully completed",
        "MYP e-Assessments successfully trialed",
        "Expansion and refurbishment of the Primary Campus",
        "Submission of application for PYP authorisation",
        "Founded the Association of Middle East and South Asia IB World Schools in Pakistan (MESA)",
        "Introduction of Global Politics in the Diploma Programme",
        "Successful trial of the PYP Exhibition",
        "Redesign of the TIS uniform"
      ]
    },
    {
      year: "2014 - 2015",
      events: [
        "Appointment of the first Principal",
        "Authorisation of Primary Years Programme from IBO",
        "Launch of co-branded Visa/UBL/TIS prepaid card",
        "Renaming of MESA to IBPAK",
        "Launch of International Days",
        "Appointment of Heads of Departments"
      ]
    }
  ];

  accordionTitle1 = "What is the old structure & culture of the school?"

  accordionContent1 = `Approved by the Board of Directors on the recommendation of the leadership, the original bureaucratic hierarchal structure with defined roles, responsibilities, policies and procedures formed the structure of the school to achieve the objectives of TIS. The Head of school reports to the Board about the academic and non-academic developments of the school and the three academic programme coordinators (Primary Years [ages 3 to 11 years], Middle Years [ages 11 to 16 years] and Diploma Years [ages 16 to 18 years]) report to the Head on their academic findings from the respective department heads and teaching staff. The Business Manager reports on the non-academic issues to the Head on findings from the support staff. The TIS community recognised the existence of ‘legal or statutory right’ or authority associated with each node on the organisational chart (Structural – Hoyle ’96) thus creating a Role Culture (p86, Handy & Aitken86). Contingent to the unfamiliar situation of establishing an IB World School in Pakistan and time-pressure in opening for admissions in a few months, the chosen structure complimented the leadership which at the time of establishing the institute was closer to “leader tells people what to do” on the Tannebaum and Schmidt Continuum (1973) and concerned more about the outcome than people (Blake, 1978). The choice of managerial leadership with top-down decision process from one key leader, the head of the school, is first rationalised by the lack of trust in the founding staff, hired months prior to the opening of the school, for admission. As described by Hersey (1985) this existed primarily due to the uncertainty of the commitment and the absence of any experience in the IB programmes of the founding staff. The collective teaching and administrative experience of the staff was of either the local Pakistani Matriculation or British GCE O- and A-level, both assessed, taught, content through examination only. In contrast TIS adoption of the inquiry based learning and criterion referenced assessment of the innovative IB system meant the previous experiences of the staff was void and they needed to change the manner in which they taught, assessed and administered learning. The lack of trust was further compounded by the lack of opportunities available to the leadership for the development of staff capacity due to constrained time frame and absence of necessary funding. Even if the budget was made available for professional development opportunities, there was no time for sending staff for external training opportunities. The paltry funds made available by the governing body in the preoperational stages of setting up the school body only secured the attendance of the Head of School to IB conferences and workshops. The concentration of the technical know-how and responsibility of training the teaching and administrative support staff, by the founding head, did further alienate the already structurally and culturally distant relation between the led and the leader. It was imperative to educate the staff in the pedagogy of the IB for its visible and effective implementation in school for parents to recognise and value the difference from the status quo, and the entire success for achieving this was central to just one person.

In contrast to Glatter’s ‘Change cannot be bulldozed’, the acceptance of managerial leadership by the initial hired staff to launch the school allowed the leadership in achieving the requisite change in record time for the implementation of the IB programmes: the outcome. This collective behaviour by almost all teaching and non-teaching staff was congruent to Hofstede’s classification of a Pakistani culture. According to Hofstede’s study, low individualism, relatively high power-distance, high masculinity and high uncertainty avoidance index in the national culture of Pakistan would suggest the preference of a more authoritative managerial leadership style by a passive led, who would rather be told what to do than be put in a situation where they could exercise their will or input. Clearly there was an alignment of structure, culture and leadership to be authoritative. However there was tension caused by the friction between the cultural acceptance of doing as the leadership demands and the individual sense of threat associated by the demands for unfamiliar or high-risk change. Thus creating Morrison’s list (1998, p130-1) of emotional negativities amongst members of the staff: “increased workload”, “loss of status and control”, “fear of the unknown”, ” lack of clarity of purpose”, “uncertainty and ambiguity”, “vulnerability”, “reluctance to let go of the present”, “threats to expertise and established skills”, “fear of failure and threats to self-esteem”, “concern about the ability to cope” and “stress” which lead to staff turnover, lack of collaboration, inconsistencies in acceptance of the IB teaching methodologies and finally more importantly sporadic visibility of the IB fundamentals by the parents.`




  accordionTitle2 = "What is the new culture of the school?"

  accordionContent2 = `TIS leadership realised “school culture is organic rather than static” (Rick Dufor, 2002, p22) and “change concerns people” (Morrison, 1998). Recognising the intrinsic link between the change in ‘the very people who make a school great or not – the teacher” (Leithwood, 92, p8) and the school. The formation of a volunteer group of teaching staff empowered to participate in deciding the future of the school was a transformational shift from autocratic to participatory leadership. This effort changed the structure by flattening the hierarchy and the culture by increasing interaction for a common goal which helps “staff members develop and maintain a collaborative, professional school culture” (Leithwood, 1992, p9). On this “retroactive” (Levacic et al., 1999) strategic platform there is a sharing and balancing of different thoughts in creating a consensus by a representative group not an individual to decide on the direction of the school. This transformation is indicative of a transition from the isolated transactional culture of a previous Type A organisation (Ouchi,’81) to the participatory and collegial culture of Type Z organisation (Ouchi,’81). The new invigorating energy from a “redefinition of a people’s mission and vision, a renewal of their commitment, and the restructuring of their systems for goal accomplishment” (Leithwood, 1992, p9) has increased “confidence and motivation” (Leithwood, 1992, p9) of staff in their transactional leadership practices. Both transformational and transactional leadership are complimentary with the former leading the change both at an individual and institutional level. ‘The alignment of the leadership, structure and culture’ (Gunter, 2006, p151) to be collaborative and participatory is an initial first in the process of making staff take ownership of the institute for its improvement and effectiveness. The visionary is no longer the founding board members but the collective school community and the change agent is no longer the Head of the school but the members of the teaching staff. Collectively they intend on bringing in improvements to reach their following agreed objectives focusing on the learner, parent and teacher – its people and community.`


  content = "Established in 1996, The International School (TIS) based on self conducted survey of the prevalent education in the city of Karachi, Pakistan and influenced by “Knowledge yielded by love. Education should have as its priorities the training of character to be fearless and affectionate and development of intellect in which interest and accuracy and usefulness and disinterestedness are balanced’ (Bertrand Russell) opened for admission as the first school in Pakistan offering the educational programmes of the International Baccalaureate Organisation (IBO). By October of the same year, the school was awarded authorisation to offer the Middle Years Programme (MYP). With this authorisation, The International School became the third school in Asia offering this newly conceived innovative education system, which incorporates the latest trends and philosophies in education. Following the successful implementation of the MYP, the school attained authorisation from the IB to offer its pre-university high school Diploma programme in August 2001. Most recently we registered with Cambridge and Ed Excel Boards (2004) to offer the International General Certificate of Secondary Education (IGCSE) programme Then, TIS was a new day coeducational private school with no track record, tradition, or societal position trying to admit students of parents with lack of knowledge and understanding of the at-offer educational programmes of IB. In a land influenced by its British colonial past, the people of Pakistan opt for either the national Pakistani Matriculation system or the prevalent British GCE O-level and A-level system. Faced against many obstacles, the first challenge for the leadership was building the capacity of a locally hired staff and determining the suitability of local resources for administering the IB programmes. The second challenge was the formation and “alignment of culture, structure and leadership to both produce and interrogate change” (Gunter, 2006, P151). In spite of the apparent dissatisfaction of the prevailing education systems as evident by own survey, the leadership had its third challenge in convincing parents on the academic benefits and future of the innovative education systems of the IBO which incorporates the latest trends and philosophies in education ."
}
